import { useNavigate, useParams } from "react-router-dom";
import { AgentChat } from "../../agent-chat/AgentChat";
import { WazToolbar } from "../toolbar/WazToolbar";
import "./WazChat.css";
import { useSelector } from "react-redux";
import { selectEditingCollection, selectUser } from "../../../redux/features/appData";
import { useEffect } from "react";

type WazChatProps = {};

export const WazChat = ({}: WazChatProps) => {

  const navigate = useNavigate();
  
  const storeUser = useSelector(selectUser);
  const editingCollection = useSelector(selectEditingCollection);

  const { collectionId } = useParams();

  // useEffect(() => {
  //   if (!collectionId) {
  //     if (editingCollection) {
  //       navigate("/waz/chat/" + editingCollection.id);
  //     } 
  //   }
  // }, []);

  if (!collectionId) {
    navigate("/waz/chat/" + editingCollection?.id);
  }

  return (
    <div className="wazawan-chat">
      <WazToolbar />
      <AgentChat />
    </div>
  );
};
